import { Line } from "vue-chartjs";
import { ChartConfig } from "@/config/chart.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gradient: null,
      chartOptions: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              tooltipItem.yLabel > 100
                ? (tooltipItem.yLabel = "> 100")
                : tooltipItem.yLabel;

              return `${data.datasets[tooltipItem.datasetIndex].label}: ${
                tooltipItem.yLabel
              }`;
            }
          }
        },
        layout: {
          padding: {
            top: 10
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              },
              type: "time",
              time: {
                minUnit: "day",
                displayFormats: {
                  minute: "DD MMM YY",
                  hour: "DD MMM YY",
                  day: "DD MMM YY",
                  week: "DD MMM YY",
                  month: "DD MMM YY"
                }
              },
              display: true,
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t(
                  "message.visibility.summary.websites.chart.yAxisLabel"
                ),
                fontSize: 16,
                padding: {
                  bottom: 10
                }
              },
              ticks: {
                min: 1,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor,
                suggestedMax: 20,
                beginAtZero: false,
                reverse: true,
                callback: function(value, index, values) {
                  values.some(val =>
                    val > 100 ? (values[values.length - 1] = 101) : false
                  );

                  if (value > 100) {
                    return "> 100";
                  }
                  return value;
                }
              }
            }
          ]
        }
      }
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 500, 0, 20);

    this.gradient.addColorStop(0.3, ChartConfig.color.danger);
    this.gradient.addColorStop(0.85, ChartConfig.color.warning);
    this.gradient.addColorStop(1, ChartConfig.color.success);

    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  computed: {
    formattedData() {
      return this.data.map(value => (value > 100 ? (value = 120) : value));
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.$t("message.common.yourPosition"),
              borderColor: this.gradient,
              pointBorderColor: this.gradient,
              pointBackgroundColor: this.gradient,
              pointHoverBackgroundColor: this.gradient,
              pointHoverBorderColor: this.gradient,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 1,
              pointRadius: 2,
              fill: true,
              clip: 3,
              backgroundColor: "transparent",
              borderWidth: 2,
              data: this.formattedData
            }
          ]
        },
        this.chartOptions
      );
    }
  }
};
